import { Breakpoint } from "@relode/core";
import { JobDetails } from "apps/client/src/shared/types";
import * as React from "react";

import { JobMarketResearchMarketingDesktop } from "./jobMarketResearchMarketingDesktop";
import { JobMarketResearchMarketingMobile } from "./jobMarketResearchMarketingMobile";

export type JobMarketResearchMarketingProps = {
    job: JobDetails;
};

export const JobMarketResearchMarketing = (
    props: JobMarketResearchMarketingProps
) => (
    <>
        <Breakpoint desktop>
            <JobMarketResearchMarketingDesktop {...props} />
        </Breakpoint>
        <Breakpoint mobile>
            <JobMarketResearchMarketingMobile {...props} />
        </Breakpoint>
    </>
);
